import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

export default function sliders() {
  const homeSlider = document.querySelector('.home-slider');
  if (homeSlider === null) {
    return;
  }

  let options = {
    root: null,
    threshold: 0.7,
  };

  function handleIntersection(entries, observer) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        homeSlider.classList.add('animation-initialized');

        setTimeout(() => {
          const swiperContainer = document.querySelector('.swiper');
          const swiperWrapper =
            swiperContainer.querySelector('.swiper-wrapper');
          const slides =
            swiperWrapper.querySelectorAll('.swiper-slide');
          const customPagination =
            document.querySelector('.pagination');
          const pauseButton = document.getElementById('swiper_pause');
          const playButton = document.getElementById('swiper_play');

          const swiperSlider = new Swiper('.swiper', {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesProgress: true,
            
            autoplay: {
              delay: 8000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            },

            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },

            on: {
              init: function (swiper) {
                activateBtnTabindex(swiper);
              },
              init: function () {
                playProgressBar();
              },
            },
          });

          swiperSlider.on('autoplayPause', function (swiper) {
            if (swiper.autoplay.paused) {
              pauseProgressBar();
              homeSlider.classList.add('home-slider--paused');
            }
          });

          swiperSlider.on('autoplayResume', function (swiper) {
            playButton.style.display = 'none';
            pauseButton.style.display = 'inline-flex';
            
            if (swiper.autoplay.running) {
              resumeProgressBar();
              homeSlider.classList.remove('home-slider--paused');
            }
          });

          swiperSlider.on('slideChange', function () {
            updatePagination();
          });

          swiperSlider.on('activeIndexChange', function (swiper) {
            const ctaButtons = document.querySelectorAll(
              '.home-slider__cta'
            );

            ctaButtons.forEach((ctaButton) => {
              ctaButton.setAttribute('tabindex', '-1');
            });

            activateBtnTabindex(swiper);
          });

          function activateBtnTabindex(swiper) {
            const activeIndex = swiper.activeIndex;
            let activeSlide = swiper.slides[activeIndex];
            const activeButton = activeSlide.querySelector(
              '.home-slider__cta'
            );

            if (activeSlide) {
              activeButton.setAttribute('tabindex', '0');
            }
          }

          function selectPagination() {
            slides.forEach((slide, index) => {
              const pagination = document.querySelectorAll(
                '.pagination__item'
              );

              for (const item of pagination)
                item.addEventListener('click', function () {
                  swiperSlider.slideTo(parseInt(this.dataset.index));
                });
            });
          }

          function updatePagination() {
            const activeIndex = swiperSlider.activeIndex;
            customPagination
              .querySelectorAll('.pagination__item')
              .forEach((page, index) => {
                if (index === activeIndex) {
                  page.classList.add('pagination__item--active');
                } else {
                  page.classList.remove('pagination__item--active');
                }
              });
          }

          pauseButton.addEventListener('click', function () {
            swiperSlider.autoplay.pause();
            pauseButton.style.display = 'none';
            playButton.style.display = 'inline-flex';
          });

          playButton.addEventListener('click', function () {
            swiperSlider.autoplay.resume();
            playButton.style.display = 'none';
            pauseButton.style.display = 'inline-flex';
          });

          function playProgressBar() {
            const pagination = document.querySelector(
              '.pagination__item'
            );
            pagination.classList.add('pagination__item--active');
          }

          function pauseProgressBar() {
            const activePagination = document.querySelector(
              '.pagination__item--active'
            );
            const progressBar =
              activePagination.querySelector('.progress-bar');
            progressBar.classList.add('progress-bar--paused');
          }

          function resumeProgressBar() {
            const activePagination = document.querySelector(
              '.pagination__item--active'
            );
            const progressBar =
              activePagination.querySelector('.progress-bar');
            progressBar.classList.remove('progress-bar--paused');
          }

          selectPagination();
        }, 5000);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, options);
  observer.observe(homeSlider);
}
